import type { PropsWithChildren, HTMLAttributes } from 'react';

import {
  Nav as BootstrapNav,
  Navbar as BootstrapNavBar,
} from 'react-bootstrap';
import styled from '@emotion/styled';
import { shadowLight } from 'app/colors';
import { breakpoints, borderRadii } from 'app/spacing';
import {
  contentWidthCss,
  pageSizingCss,
} from 'components/Layout/PageContentWidth';

export const BaseSubNavigationNavBar = ({
  children,
  ...rest
}: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) => {
  return (
    <div {...rest}>
      <BootstrapNavBar variant="light" expand="md">
        <BootstrapNav className="ml-auto" data-qa="subnavigation">
          {children}
        </BootstrapNav>
      </BootstrapNavBar>
    </div>
  );
};

export const SubNavigationNavBar = styled(BaseSubNavigationNavBar)`
  ${pageSizingCss}
  & .navbar {
    position: relative;
    ${contentWidthCss}
    border-radius: ${borderRadii.standard};
    ${shadowLight}
    background: var(--color-background-white);
    padding: 0;
  }
  & .navbar-nav {
    flex: 1;
    justify-content: space-evenly;
    flex-direction: row !important;
  }
  @media (max-width: ${breakpoints.md}px) {
    & .navbar {
      margin: 10px auto;
    }
    & .navbar-nav {
      align-items: flex-start;
    }
    & .navbar {
      border-radius: 0;
      width: 100%;
    }
    & .navbar-toggler {
      margin: 10px;
    }
  }
`;

export const SmallSubNavigationNavBar = styled(({ children, ...props }) => (
  <div {...props}>
    <nav>{children}</nav>
  </div>
))`
  display: flex;
  justify-content: center;
  > nav {
    display: flex;
    background-color: var(--color-background-white);
    ${shadowLight}
  }
`;
